const isVowel = (char: string): boolean => {
  if (!char) return false;
  return ['a', 'e', 'i', 'o', 'u'].indexOf(char.toLowerCase()) !== -1;
};

export default isVowel;
